import { render, staticRenderFns } from "./ExpandProperties.vue?vue&type=template&id=20040804"
import script from "./ExpandProperties.vue?vue&type=script&lang=js"
export * from "./ExpandProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports